import { useState } from 'react';

import { useCompoundContext } from '@/components/Header/context';
import type { TypographyProps } from '@/components/Typography';
import { Typography } from '@/components/Typography';

import * as S from './MobileMenuAccordion.styles';

export interface MobileMenuAccordionProps {
  children: React.ReactNode;
  title: string;
  titleProps?: Omit<TypographyProps, 'children'>;
}

export const MobileMenuAccordion = ({
  children,
  title,
  titleProps = { as: 'p' },
}: MobileMenuAccordionProps) => {
  useCompoundContext();
  const [isOpen, setIsOpen] = useState(false);
  const id = title.replace(/\s+/g, '');

  return (
    <S.Wrapper data-testid='MobileMenuAccordionWrapper'>
      <S.Header
        data-test-id='MobileMenuAccordionHeader'
        data-testid='MobileMenuAccordionHeader'
      >
        <S.HeaderContent
          aria-controls={id}
          aria-expanded={isOpen}
          data-test-id='MobileMenuAccordionHeaderContent'
          forwardedAs='button'
          isOpen={isOpen}
          onClick={() => setIsOpen?.(!isOpen)}
        >
          <Typography {...titleProps} data-test-id='MobileMenuAccordionTitle'>
            {title}
          </Typography>
          {isOpen ? (
            <S.ArrowUpIcon data-test-id='MobileMenuAccordionArrowIcon' />
          ) : (
            <S.ArrowRightIcon data-testid='MobileMenuArrowRightIcon' />
          )}
        </S.HeaderContent>
      </S.Header>
      <S.SubMenuItemsContainer
        $isOpen={isOpen}
        data-test-id='MobileMenuAccordionItemsContainer'
      >
        {children}
      </S.SubMenuItemsContainer>
    </S.Wrapper>
  );
};

MobileMenuAccordion.displayName = 'MobileMenuAccordion';
